import * as React from 'react';
import styled from 'styled-components';
const Wrapper = styled.div `
  display: flex;
  flex-direction: column-reverse;
  max-width: 250px;
`;
const Label = styled.label `
  font-size: 12px;
  font-weight: 400;
  padding-bottom: 7px;
`;
const Input = styled.input `
  all: unset;
  box-shadow: inset 0 -2px 0 0 rgba(0, 0, 0, 0.15);
  margin-right: 24px;
  max-width: 138px;
  padding-bottom: 4px;
  transition: all 200ms ease;

  &:hover {
    box-shadow: inset 0 -2px 0 0 rgba(0, 0, 0, 0.35);
  }

  &:focus {
    box-shadow: inset 0 -2px 0 0 rgba(0, 0, 0, 0.85);
  }

  &:focus ~ ${Label} {
    font-weight: 500;
  }
`;
const TextInput = ({ name, label, value, onChange, className, autoFocus }) => (React.createElement(Wrapper, { className: className },
    React.createElement(Input, { autoComplete: "off", autoCorrect: "off", autoCapitalize: "off", spellCheck: false, type: "text", id: name, name: name, value: value, onChange: onChange, autoFocus: autoFocus }),
    label && React.createElement(Label, { htmlFor: name }, label)));
export default TextInput;
